import { render, staticRenderFns } from "./GeraParcelas.vue?vue&type=template&id=3701d790"
import script from "./GeraParcelas.vue?vue&type=script&lang=js"
export * from "./GeraParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports